import React, { FC, Suspense, useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import useRootSelector from 'common/hooks/useRootSelector';
import { Box } from '@material-ui/core';
import { selectIsUserLoggedIn } from 'modules/authentication/state/selectors';
import { NavigationContext } from 'common/createContext/navigationContext';
import { Header, Sidebar } from 'components';
import { Routes as Paths } from 'constants/route.constants';
import { LoadingBackdrop } from 'common/components';
import { selectIsMemberPortalUserLoggedIn } from 'memberPortalModules/authentication/state/selectors';
import useOnce from 'common/hooks/useOnce';
import PermissionContextProvider from 'common/containers/PermissionContextProvider/PermissionContextProvider';
import PermissionLevelContextProvider from 'common/containers/PermissionLevelContextProvider/PermissionLevelContextProvider';
import PrivateRotes from './PrivateRotes';
import PublicRoutes from './PublicRoutes';
import CancelRequestService from 'services/http/CancelRequestService';
import RouterService from 'services/application/RouterService';
import SidebarContextProvider from 'components/Sidebar/SidebarContextProvider';

const Routes: FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { showNavigation } = useContext(NavigationContext);
  const clientPortalUserLogged = useRootSelector(selectIsUserLoggedIn);
  const memberPortalUserLogged = useRootSelector(selectIsMemberPortalUserLoggedIn);
  const userLogged = clientPortalUserLogged || memberPortalUserLogged;
  const pathname = location.pathname;
  const isBookingSharedPage = pathname === Paths.BOOKING_SHARED;

  useOnce(() => {
    RouterService.setNavigator(navigate);
    return true;
  });

  useEffect(() => {
    return () => {
      CancelRequestService.cancelRouteRequests(pathname);
    };
  }, [pathname]);

  return (
    <PermissionContextProvider skip={!clientPortalUserLogged}>
      <PermissionLevelContextProvider>
        <SidebarContextProvider>
          <Box display="flex" height="100vh" width="100vw" flexDirection="column">
            {showNavigation && userLogged && !isBookingSharedPage ? <Header /> : null}

            <Box display="flex" flexGrow={1} minHeight={0} minWidth={0} position="relative">
              {showNavigation && userLogged && !isBookingSharedPage ? <Sidebar /> : null}

              <Box width="100%" className="pageWrapper" height="100%" flex={1}>
                <Suspense fallback={<LoadingBackdrop />}>
                  {!userLogged ? <PublicRoutes /> : <PrivateRotes />}
                </Suspense>
              </Box>
            </Box>
          </Box>
        </SidebarContextProvider>
      </PermissionLevelContextProvider>
    </PermissionContextProvider>
  );
};

export default Routes;
